// extracted by mini-css-extract-plugin
export default {"modal-window":"ModalWindow_modal-window__v3zA7"};